export const permission = {
  admin: {
    candidateapplieddetail: true,
    candidatedetail: true,
    candidateslist: true,
    dashboard: true,
    institutionlist: true,
    institutionadd: true,
    listjob: true,
    universitylist: true,
    universityadd: true,
    employerlist: true,
    employeradd: true,
    linkinguniversity: true,
    recruiterlinkinguniversity: true,
    recruiterlist: true,
    recruiteradd: true,
    modalpopup: true,
    jobdetail: true,
    addDrive: true,
    drivelist: true,
    drivedetail: true,
    selectedcandidate: true,
    DriveSelectedCandidate: true,
    appliedcandidatelist: true,
    allselectcandidatelist: true,
    allcandidatelist: true,
    listenquiry: true,
    changepassword: true,
    support: true,
    profile: true,
    universityedit: true,
    recruiteredit: true,
    universityprofile: true,
    institutionprofile: true,
    recruiterprofile: true,
    employerprofile: true,
    notification: true,
    masterskillslist: true,
    mastersectorslist: true,
    mastercourseslist: true,
    masterstateslist: true,
    mastercitieslist: true,
    mastersectoradd: true,
    masteraddskill: true,
    masterstateadd: true,
    mastercoursesadd: true,
  },
  institute: {
    candidateapplieddetail: true,
    candidatedetail: true,
    dashboard: true,
    modalpopup: true,
    jobdetail: true,
    addCandidate: true,
    drivelist: true,
    drivedetail: true,
    selectedcandidate: true,
    DriveSelectedCandidate: true,
    candidateslist: true,
    changepassword: true,
    institutionprofile: true,
    profile: true,
    listjob: true,
    instituteprofile: true,
    allselectcandidatelist: true,
    notification: true,
    institutionadd: true,
  },
  recruiter: {
    candidateapplieddetail: true,
    candidatedetail: true,
    dashboard: true,
    //institutionadd:true,
    listjob: true,
    addjob: true,
    modalpopup: true,
    jobdetail: true,
    addDrive: true,
    drivelist: true,
    drivedetail: true,
    profile: true,
    selectedcandidate: true,
    DriveSelectedCandidate: true,
    changepassword: true,
    support: true,
    recruiterprofile: true,
    recruiteredit: true,
    allselectcandidatelist: true,
    notification: true,
  },
  employer: {
    candidateapplieddetail: true,
    candidatedetail: true,
    dashboard: true,
    modalpopup: true,
    jobdetail: true,
    drivelist: true,
    listjob: true,
    drivedetail: true,
    selectedcandidate: true,
    DriveSelectedCandidate: true,
    allselectcandidatelist: true,
    appliedcandidatelist: true,
    allcandidatelist: true,
    candidateslist: true,
    employerprofile: true,
    employeradd: true,
    changepassword: true,
    support: true,
    profile: true,
    notification: true,
  },
  candidates: {
    dashboard: true,
    modalpopup: true,
    jobdetail: true,
    drivelist: true,
    drivedetail: true,
    profile: true,
    applieddrivelist: true,
    selecteddrivelist: true,
    candidateapplieddetail: true,
    candidatedetail: true,
    changepassword: true,
    support: true,
    notification: true,
  },
  university: {
    candidateapplieddetail: true,
    candidatedetail: true,
    dashboard: true,
    modalpopup: true,
    listjob: true,
    jobdetail: true,
    drivelist: true,
    drivedetail: true,
    selectedcandidate: true,
    DriveSelectedCandidate: true,
    candidateslist: true,
    changepassword: true,
    support: true,
    universityprofile: true,
    profile: true,
    institutionlist: true,
    institutionadd: true,
    universityedit: true,
    institutionprofile: true,
    allselectcandidatelist: true,
    notification: true,
  },
  company: {
    dashboard: true,
    modalpopup: true,
    jobdetail: true,
    drivedetail: true,
    DriveSelectedCandidate: true,
    changepassword: true,
    support: true,
    profile: true,
    notification: true,
  },
  lead: {
    dashboard: true,
  },
};

export const roles = {
  1: "admin",
  2: "institute",
  3: "recruiter",
  4: "employer",
  5: "candidates",
  6: "university",
  7: "company",
  8: "lead",
};
